import Highcharts from 'sdbbJsAssets/charts/_highcharts-base';
import {Options} from 'highcharts';

$(function () {
    const defaultOptions: Options = {
        chart: {
            width: 594,
            height: 425,
            spacingTop: 10,
            spacingLeft: 0,
            marginLeft: 210,
            marginRight: 5,
            type: 'columnrange',
            inverted: true,
            plotBorderWidth: 1,
            plotBorderColor: 'black',
            events: undefined,
        },
        yAxis: {
            title: {
                // Text null means title is disabled,
                // enable it by overwriting the text
                text: null,
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                }
            },
            labels: {
                style: {
                    color: 'black'
                }
            },
            gridLineColor: 'black',
            min: 20,
            max: 80,
            tickInterval: 10
        },
        colors: [
            'black',
            '#295f99',
            '#00a833',
            '#bf003f',
            '#434348',
            '#ff7f7f',
            '#994b00',
            '#542f8c',
            '#ffff00',
            '#94afcc',
            '#89c172'
        ]
    };
    Highcharts.setOptions(defaultOptions);
});
export default Highcharts;